module.exports = __webpack_public_path__ + "img/arrow.fe1339bc.svg";